<script setup lang="ts">
defineProps<{
  partnerSaleReservationId: string
}>()
</script>

<template>
  <ThePopup show :title="$t('customerModule.reservation.commentsPopup.title')">
    <CustomerModuleCommentList :entity-id="partnerSaleReservationId" type="PartnerSaleReservation" is-delete-disabled sort="desc" />
  </ThePopup>
</template>
